// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logs[data-v-face77dc] {\n  background-color: rgb(241, 241, 241);\n  height: 300px;\n  overflow: auto;\n  padding: 10px;\n  border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
